module.exports = __webpack_public_path__ + "/images/cover-pareja-pensativa-540.4f2a7c5.jpg";